import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';
import { useQuery } from 'react-query';
import API from 'core/Api';
import { IDropdowns } from '../components/types';
import CreateForm from './components/CreateForm';

const Screen: FC = () => {
  const {
    isLoading,
    error,
    data: dropdowns,
  } = useQuery<IDropdowns, Error>(['user-dropdowns'], (): Promise<IDropdowns> => {
    return API.get('users/dropdown-options').then(res => res.data && res.data.bg);
  });

  return (
    <MainLayout
      title="Добавяне на оператор"
      isLoading={isLoading}
      error={error}
    >
      {dropdowns && <CreateForm userDataOptions={dropdowns} />}
    </MainLayout>
  );
};

export default Screen;
